import { KdsSpinner } from "@kazaar-platform/design-system";
import { useAtomValue } from "jotai";
import { Suspense, useEffect } from "react";
import { RouterProvider } from "react-router-dom";

import { useImageErrorTracking } from "@/hooks/useImageErrorTracking";
import { setAxeptioSettings } from "@/instrument";
import { userAtom } from "@/store";

import { router } from "../Routes";

export const RootPage = () => {
  const userAtomValue = useAtomValue(userAtom);

  useImageErrorTracking();

  useEffect(() => {
    setAxeptioSettings(userAtomValue?.lang || "en");
  }, [userAtomValue?.lang]);

  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center">
          <KdsSpinner size="lg" />
        </div>
      }
    >
      <RouterProvider router={router} />
    </Suspense>
  );
};
